import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import isNull from 'lodash/isNull';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles, Button, Checkbox, FormControlLabel } from '@material-ui/core';
import { getI18n } from "../../../utils/intl";

import styles from './styles';

const CustomFilterButtonBar = (props) => {
  const {
    updatedGroupSelection, onApply, disableApplyBtn, disableGrouped,
    showGroupCheckBox, isGroupedSelected, onCancel, removeFilter,
  } = props;

  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const [isFilterGrouped, setIsFilterGrouped] = useState(isGroupedSelected);

  const isGroupedSelectedRef = useRef(isGroupedSelected);
  useEffect(() => {
    if (isGroupedSelected !== isGroupedSelectedRef.current) {
      setIsFilterGrouped(isGroupedSelected);
    }
    isGroupedSelectedRef.current = isGroupedSelected;
  }, [isGroupedSelected]);

  useEffect(() => {
    return () => {
      document.removeEventListener('mousedown', handleClick, false);
      document.removeEventListener('keydown', handleKeyDown, false);
    }
  }, []);

  useEffect(() => {
    updatedGroupSelection(isFilterGrouped);
  }, [isFilterGrouped]);

  const handleGroupedBtnClick = () => {
    setIsFilterGrouped(prevState => !prevState);
  };

  const handleClick = (event) => {
    if (event.which === 1) {
      const targetElement = event.target;
      const filterContainer = targetElement.closest('#filter-container');
      if (isNull(filterContainer)) {
        onCancel();
      }
    }
  };

  const handleKeyDown = event => {
    if (event.keyCode === 27) {
      onCancel();
    }
  };
  
  const handleRemoveBtnClick = () => {
    removeFilter();
  }

  return (
    <div className={classes.buttonBar}>
      <Button className={classes.removeButton} data-apim-test={'remove-btn'} onClick={handleRemoveBtnClick}>
        {intl.getI18nMessage('label.analytics.dashboard.label.remove')}
      </Button>
      <div className={classes.buttonGroup}>
        {showGroupCheckBox ? (
          <FormControlLabel
            control={
              <Checkbox
                onChange={handleGroupedBtnClick}
                checked={isFilterGrouped}
                disabled={disableGrouped}
              />
            }
            label={intl.getI18nMessage("label.analytics.customReport.filter.grouped.checkbox.label")}
          />
        ) : null}
        <Button
          data-apim-test={'apply-btn'}
          disabled={disableApplyBtn}
          onClick={() =>
            onApply(isFilterGrouped)}
          className={clsx(
            classes.applyBtn,
            classes.button,
          )}
        >
          {intl.getI18nMessage('label.analytics.dashboard.label.apply')}
        </Button>
        <Button
          className={classes.cancelBtn}
          data-apim-test={'cancel-btn'}
          primary
          onClick={onCancel}
        >
          {intl.getI18nMessage('label.analytics.dashboard.label.cancel')}
        </Button>
      </div>
    </div>
  );
}

CustomFilterButtonBar.propTypes = {
  disableApplyBtn: PropTypes.bool,
  onCancel: PropTypes.func,
  showGroupCheckBox: PropTypes.bool,
  onApply: PropTypes.func,
  isGroupedSelected: PropTypes.func,
  removeFilter: PropTypes.func,
  updatedGroupSelection: PropTypes.func,
  disableGrouped: PropTypes.bool,
};

export default CustomFilterButtonBar;
